module.exports = __webpack_public_path__ + "static/media/loader.7e7215da.svg";